import Employers from "./employers.component.vue";

export default Employers;
